import HTTPService from '@/api/http/HTTPService'
import BrandInterface from './BrandInterface'

export default {
  getAll: (): object => HTTPService.get('admin/brand'),
  getOne: (brandId: number): object => HTTPService.get(`admin/brand/${brandId}`),
  update: (brandId: number, payload: BrandInterface): object => HTTPService.put(`admin/brand/${brandId}`, payload),
}
